import { DatePicker, Form, Select } from 'antd';
import dayjs from 'dayjs';
import { localize } from 'mixins/helpers';
import React, { FC } from 'react';
import {
    LOAD_TYPES,
    MONTH_NUMBERS_TYPES,
} from '/react4xp/parts/calc-transport/calc-transport-consts';

const TruckForm: FC = (props: any) => {
    return (
        <Form
            form={props.form}
            className="w-100"
        >
            <Form.Item
                name="year"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <DatePicker
                    placeholder={localize('calc-transport-criteria-2', props.translations)}
                    format={'YYYY'}
                    picker="year"
                    maxDate={dayjs()}
                />
            </Form.Item>

            <Form.Item
                name="numberOfMonthsInUse"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <Select
                    options={MONTH_NUMBERS_TYPES}
                    placeholder={localize('calc-transport-criteria-3', props.translations)}
                    allowClear
                />
            </Form.Item>

            <Form.Item
                name="loadCapacityId"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <Select
                    allowClear
                    options={LOAD_TYPES.map((e) => ({
                        key: e.key,
                        value: e.value,
                        label: localize(e.label, props.translations),
                    }))}
                    placeholder={localize('calc-transport-criteria-4', props.translations)}
                />
            </Form.Item>
        </Form>
    );
};

export default TruckForm;
